/**
 * 配置站点地图路由
 * @priority 0.5
 * @changefreq weekly
 */

//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    //* 关于我们
    {
        name: "About",
        path: "/about",
        component: () => import("@/views/public/exhibits/about/index.vue"),
    },
    {
        name: "ContactUs",
        path: "/contact-us",
        meta: { type: "Contact Us" },
        component: () => import("@/views/contact-us/index.vue"),
    },
    {
        name: "Privacy",
        path: "/privacy",
        component: () => import("@/views/public/exhibits/privacy/index.vue"),
    },
    {
        name: "UserAgreement",
        path: "/user-agreement",
        component: () => import("@/views/user-agreement/index.vue"),
    },
    //* 教程
    {
        path: "/tutorials",
        name: "Tutorials",
        component: () => import("@/views/tutorials/index.vue"),
    },
    {
        path: "/tutorials/rna-splicer",
        name: "RnaSplicerTutorials",
        component: () => import("@/views/tutorials/views/rna-splicer/index.vue"),
    },
    {
        path: "/tutorials/pathogenicity",
        name: "PathogenicityTutorials",
        component: () => import("@/views/tutorials/views/pathogenicity/index.vue"),
    },
    {
        path: "/tutorials/sequence-alignment",
        name: "SequenceAlignmentTutorials",
        component: () => import("@/views/tutorials/views/sequence-alignment/index.vue"),
    },
    {
        path: "/tutorials/sequence",
        name: "SequenceViewerTutorials",
        component: () => import("@/views/tutorials/views/sequence/index.vue"),
    },
    {
        path: "/tutorials/sequence-processor",
        name: "SequenceProcessorTutorials",
        component: () => import("@/views/tutorials/views/sequence-processor/index.vue"),
    },
    {
        path: "/tutorials/variant",
        name: "VariantTutorials",
        component: () => import("@/views/tutorials/views/variant/index.vue"),
    },
    {
        path: "/tutorials/genetic-comparison",
        name: "GeneticComparisonTutorials",
        component: () => import("@/views/tutorials/views/genetic-comparison/index.vue"),
    },
    {
        path: "/tutorials/diseases-comparison",
        name: "DiseasesComparisonTutorials",
        component: () => import("@/views/tutorials/views/diseases-comparison/index.vue"),
    },
    {
        path: "/tutorials/model-comparison",
        name: "ModelComparisonTutorials",
        component: () => import("@/views/tutorials/views/model-comparison/index.vue"),
    },
    //* 网站介绍（特色）
    {
        path: "/timely-upadated",
        name: "TimelyUpadated",
        component: () => import("@/views/timely-upadated/index.vue"),
    },
    {
        path: "/data-visualization",
        name: "DataVisualization",
        component: () => import("@/views/data-visualization/index.vue"),
    },
    {
        path: "/data-simplication",
        name: "DataSimplication",
        component: () => import("@/views/data-simplication/index.vue"),
    },
    {
        path: "/all-in-one",
        name: "AllInOne",
        component: () => import("@/views/all-in-one/index.vue"),
    },
    {
        path: "/workflow/workflow1",
        name: "Workflow",
        component: () => import("@/views/workflow/workflow1/index.vue"),
    },
    {
        path: "/workflow/variantseek",
        name: "Variantseek",
        component: () => import("@/views/workflow/variantseek/index.vue"),
    },
    {
        path: "/downloads",
        name: "Downloads",
        component: () => import("@/views/downloads/index.vue"),
    },
    {
        path: "/citations",
        name: "Citations",
        component: () => import("@/views/citations/main/index.vue"),
    },
    {
        path: "/citations/:id",
        name: "CitationsDetails",
        meta: { regular_type: "citations", regular: ":id" },
        component: () => import("@/views/citations/details/index.vue"),
    },
] as RouteRecordRaw[];
